import { render, staticRenderFns } from "./GiserAcknowledgmentSection.vue?vue&type=template&id=44ac4101&scoped=true"
import script from "./GiserAcknowledgmentSection.vue?vue&type=script&lang=js"
export * from "./GiserAcknowledgmentSection.vue?vue&type=script&lang=js"
import style0 from "./GiserAcknowledgmentSection.vue?vue&type=style&index=0&id=44ac4101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac4101",
  null
  
)

export default component.exports